import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Select,
  MenuItem,
  Typography,
  Box,

} from "@mui/material";

const smsTemplates = [
  { id: 1, name: "Reminder", message: "Reminder: you have a video interview with {company_name}. Start your interview here: {short_interview_url}" },
  { id: 2, name: "Invitation", message: "Hello, this is a Invitation regarding your interview with {company_name}. Please check {short_interview_url}" },
];

const SMSTemplateModal = ({ open, onClose, templateData, refreshTemplates }) => {
  const [selectedTemplate, setSelectedTemplate] = useState(smsTemplates[0]);


  useEffect(() => {
    if (templateData) {
      const foundTemplate = smsTemplates.find(t => t.name === templateData.type);
      if (foundTemplate) {
        setSelectedTemplate({ ...foundTemplate, message: templateData.sms_content });
      }
    }
  }, [templateData]);

  const handleCreateTemplate = async () => {
    const payload = {
      sms_template_id: templateData?.id,
      type: selectedTemplate.name,
      sms_content: selectedTemplate.message
    };


    try {
      const response = await fetch(templateData ? `https://api.a2ajobs.com/api/sms-template-update` : "https://api.a2ajobs.com/api/sms-template-create", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        alert(`SMS Template ${templateData ? "Updated" : "Saved"} Successfully!`);
        onClose();
      } else {
        console.error("Failed to create template");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };


  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Select a base template</DialogTitle>
      <DialogContent>
        <Typography sx={{ mb: 1 }}>Template</Typography>
        <Select
          fullWidth
          value={selectedTemplate.id}
          onChange={(e) =>
            setSelectedTemplate(smsTemplates.find(t => t.id === e.target.value))
          }
        >
          {smsTemplates.map((template) => (
            <MenuItem key={template.id} value={template.id}>
              {template.name}
            </MenuItem>
          ))}
        </Select>

        <Box sx={{ mt: 3, textAlign: "center", p: 2, background: "#f5f5f5", borderRadius: "10px" }}>
          <Typography variant="caption">Aitutor</Typography>
          <Box sx={{ display: "inline-block", p: 2, background: "#e0e0e0", borderRadius: "8px" }}>
            <Typography variant="body2">{selectedTemplate.message}</Typography>
          </Box>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" color="primary" onClick={handleCreateTemplate}> {templateData ? "Update Template" : "Create Template"}</Button>
      </DialogActions>


    </Dialog>
  );
};

export default SMSTemplateModal;
